import { h, render, Component } from 'preact';

class TxrMobileHeader extends Component {
    state = {
    }
    render() {
        return (
            <header class="txr-mobile-header">
                <div class="txr-mobile-header__content">
                    <a class="txr-header__logo" href="/">
                        <img alt="logo" src="/images/logo-whitegreen-esendex.svg" />
                    </a>
                    <div class="txr-header__mobile-button" onClick={this.props.onClose}>
                        <i class="fal fa-times" />
                    </div>
                </div>
            </header>
        )
    }
}

export default TxrMobileHeader;